// API Utility Functions
// Common functions used across the application for API calls

// Helper function to get headers for API requests
export const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json'
  };
  
  const token = localStorage.getItem('token');
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
};

// Helper function to get storage value
export const getStorage = (key) => {
  return localStorage.getItem(key);
};

// Helper function to set storage value
export const setStorage = (key, value) => {
  localStorage.setItem(key, value);
};

// Helper function to remove storage value
export const removeStorage = (key) => {
  localStorage.removeItem(key);
};

// Helper function to clear all storage
export const clearStorage = () => {
  localStorage.clear();
};

// Helper function for API error handling
export const handleApiError = (error) => {
  let errorMessage = "An error occurred. Please try again.";
  
  if (error.response) {
    // Server responded with error status
    errorMessage = error.response.data?.message || `Server Error: ${error.response.status}`;
  } else if (error.request) {
    // Network error
    errorMessage = "Network error. Please check your internet connection.";
  } else {
    // Other error
    errorMessage = error.message || errorMessage;
  }
  
  return errorMessage;
};

// Common API function to track page navigation
export const trackPageNavigation = async (pageURL) => {
  try {
    const applicationId = getStorage('application_id');
    if (!applicationId) {
      console.warn('Application ID not found in storage');
      return;
    }

    const environment = await import('../environment.js').then(module => module.default);
    
    const response = await fetch(
      `${environment.apiurl}applications/${applicationId}/ui_management_multi/loan/save/?status=${pageURL}`,
      {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({})
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Page navigation tracked successfully:', pageURL);
    return data;
  } catch (error) {
    console.error('Error tracking page navigation:', error);
    // Don't throw error to avoid breaking the navigation flow
    return null;
  }
};

const apiUtils = {
  getHeaders,
  getStorage,
  setStorage,
  removeStorage,
  clearStorage,
  handleApiError,
  trackPageNavigation
};

export default apiUtils;
